<template>
  <div>
    <facit-header></facit-header>
      <div class = "profile-div col-12">
        <h5 class="mt-3 mb-3"><a @click="getCountry()" class="Userlink">
                                  Country List</a> / License Detail </h5>
        <b-row class="float-right">
          <b-col class="my-1">
            <b-form-group horizontal label="" class="mb-3">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Search" />
                <b-btn class="clearBtn" :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-table  striped hover v-if="!allowStatusChanged"
                  show-empty
                  empty-text="There is no license history to show"
                  :fields="tableFields"
                  :filter="filter"
                  :items="history"
                  :current-page="currentPage"
                  :per-page="perPage">
        </b-table>
        <b-table  striped hover v-if="allowStatusChanged"
                  show-empty
                  empty-text="There is no license history to show"
                  :fields="tableFieldsStatus"
                  :filter="filter"
                  :items="history"
                  :current-page="currentPage"
                  :per-page="perPage">
                  <template slot="invoiced" slot-scope="data">
                    <label class="switch">
                    <input type="checkbox"
                           v-model="data.value"
                           @change="statusUpdate(data.item.userId,data.item.id,data.value)">
                    <span class="slider round"></span>
                  </label>
                  </template>
                  <template slot="link" slot-scope="data">
                    <i @click="getLicenceDetail(data.item.userId,data.item.id)" title="Update Store Status">
                      <v-icon name="edit" base-class="icon-width" @click="getLicenceDetail(data.item.userId,data.item.id)">
                      </v-icon>
                    </i>
                    <i @click="showLicenseDetail(data.item.id)" title="License Detail">
                      <v-icon name="info" base-class="icon-width" @click="showLicenseDetail(data.item.id)">
                      </v-icon>
                    </i>
                  </template>
        </b-table>

        <b-modal v-model="userSettingsModal" hide-footer title="Update Store Status">
          <b-form @submit.prevent="updateStoreStatus('formRegistration')"
                  class="ml-4 mr-4 mb-4"
                  data-vv-scope="formRegistration">
            <b-form-group id="nameGroup">
              <b-row class="my-1">
                <b-col sm="4">
                  <label for="input-small">Current Status</label>
                </b-col>
              <b-col sm="8">
                <b-form-select id="currentStatus"
                               name="currentStatus"
                               v-model="currentStatus"
                               :options="storeStatusOptions"
                               v-validate="'required'"
                               :class="{'input': true,
                                        'is-danger': errors.has('formRegistration.currentStatus') }"
                               required> </b-form-select>
              </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="4">
                  <label for="input-small">Notes</label>
                </b-col>
              <b-col sm="8">
                <b-form-textarea id="clientNotes"
                            type="text"
                            name="clientNotes"
                            v-model="clientNotes"
                            placeholder="Notes">
                 </b-form-textarea>
              </b-col>
              </b-row>
            </b-form-group>
            <b-button
              type="submit"
              class="w-100"
              variant="warning">Update</b-button>
          </b-form>
        </b-modal>
        <b-modal size="lg" v-model="licenseDetailModal" hide-footer title="License Detail">
            <b-form-group id="nameGroup">
              <b-row class="my-1">
                <b-col sm="4">
                  <label for="input-small">Product Key</label>
                </b-col>
              <b-col sm="8">
                <label for="input-small">{{productKey}}</label>
              </b-col>
              </b-row>
            </b-form-group>
            <b-form-group id="nameGroup">
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">License Key</label>
                </b-col>
              <b-col sm="10">
                <label for="input-small">{{licenseKey}}</label>
              </b-col>
              </b-row>
            </b-form-group>
            <b-form-group id="nameGroup">
              <b-row class="my-1">
                <b-col sm="6">
                  <label for="input-small">People Counter Perspective</label>
                </b-col>
              <b-col sm="6">
                <label for="input-small">{{PeopleCounterPerspective}}</label>
              </b-col>
              </b-row>
            </b-form-group>
            <b-form-group id="nameGroup">
              <b-row class="my-1">
                <b-col sm="6">
                  <label for="input-small">People Counter OverHead</label>
                </b-col>
              <b-col sm="6">
                <label for="input-small">{{PeopleCounterOverHead}}</label>
              </b-col>
              </b-row>
            </b-form-group>
            <b-form-group id="nameGroup">
              <b-row class="my-1">
                <b-col sm="6">
                  <label for="input-small">Heat Map</label>
                </b-col>
              <b-col sm="6">
                <label for="input-small">{{heatMap}}</label>
              </b-col>
              </b-row>
            </b-form-group>
            <b-form-group id="nameGroup">
              <b-row class="my-1">
                <b-col sm="6">
                  <label for="input-small">Queue Manager</label>
                </b-col>
              <b-col sm="6">
                <label for="input-small">{{queueManager}}</label>
              </b-col>
              </b-row>
            </b-form-group>
            <b-form-group id="nameGroup">
              <b-row class="my-1">
                <b-col sm="6">
                  <label for="input-small">False Direction</label>
                </b-col>
              <b-col sm="6">
                <label for="input-small">{{falseDirection}}</label>
              </b-col>
              </b-row>
            </b-form-group>
            <b-form-group id="nameGroup">
              <b-row class="my-1">
                <b-col sm="6">
                  <label for="input-small">People Counter Next Generation</label>
                </b-col>
              <b-col sm="6">
                <label for="input-small">{{peopleCounterNew}}</label>
              </b-col>
              </b-row>
            </b-form-group>
        </b-modal>
        <br>
        <b-pagination align="right"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      v-model="currentPage"
                      class="my-0" />
      <br><br>
      </div>
  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';
import moment from 'moment';
import _ from 'lodash';

export default {
  name: 'licenseDetail',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      history: null,
      userSettingsModal: false,
      filter: null,
      moment: moment,
      allowStatusChanged: false,
      userSettingsModal: false,
      currentStatus: null,
      licenceId: null,
      licenceUserId: null,
      selectedCountry: null,
      clientNotes: null,
      PeopleCounterPerspective: 0,
      PeopleCounterOverHead: 0,
      peopleCounterNew: 0,
      heatMap: 0,
      queueManager: 0,
      falseDirection: 0,
      productKey: null,
      licenseKey: null,
      licenseDetailModal: false,
      invoiced: false,
      storeStatusOptions: [
        { value: 'Pre Install', text: 'Pre Install' },
        { value: 'In Progress', text: 'In Progress' },
        { value: 'Completed', text: 'Completed' },
        { value: 'Delayed', text: 'Delayed' },
      ],
      tableFields: [
        {
          key: 'customerName',
          label: 'Customer Name',
          sortable: true,
        },
        {
          key: 'storeId',
          label: 'Store Id',
          sortable: true,
        },
        {
          key: 'storeName',
          label: 'Store Name',
          sortable: true,
        },
        {
          key: 'country',
          label: 'Country',
          sortable: true,
        },
        {
          key: 'installationDate',
          label: 'Installation Date',
          sortable: true,
          formatter: (value) => {
            return moment.utc(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'goLiveDate',
          label: 'Go Live Date',
          sortable: true,
          formatter: (value) => {
            return moment.utc(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'issueDate',
          label: 'Issue Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'expiryDate',
          label: 'Expiry Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'currentStatus',
          label: 'Current Status',
          sortable: true,
        },
      ],
      tableFieldsStatus: [
        {
          key: 'customerName',
          label: 'Customer Name',
          sortable: true,
        },
        {
          key: 'storeId',
          label: 'Store Id',
          sortable: true,
        },
        {
          key: 'storeName',
          label: 'Store Name',
          sortable: true,
        },
        {
          key: 'country',
          label: 'Country',
          sortable: true,
        },
        {
          key: 'installationDate',
          label: 'Installation Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'goLiveDate',
          label: 'Go Live Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'issueDate',
          label: 'Issue Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'expiryDate',
          label: 'Expiry Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'currentStatus',
          label: 'Current Status',
          sortable: true,
        },
        {
          key: 'clientNotes',
          label: 'Note',
          sortable: false,
        },
        {
          key: 'invoiced',
          label: 'Invoiced',
          sortable: true,
        },
        {
          key: 'link',
          label: 'Action',
          sortable: false,
        },
      ],
    };
  },
  async created() {
    const country = this.$route.query.id;
    this.selectedCountry = country
    this.getHistory(country);
    const userRole = Session.getAccessToken().user.role;
    if (userRole === 'admin' || userRole === 'subadmin') {
      this.allowStatusChanged = true
    }
  },
  methods: {
    async getHistory(country) {
      const clientId = '3cc10ad0-9c12-11ea-b1b3-a3c431850c62'
      const historyData = await API.get(`Accounts/${clientId}/Licence?filter={"where": {"country": "${country}", "licenceType": 2, "cancelled": false}}`);
      this.history = _.orderBy(historyData, ['id'], ['desc'])
      this.totalRows = this.history.length;
    },
    async getLicenceDetail(userId, id) {
      const licenceDetail = await API.get(`Accounts/${userId}/Licence/${id}`);
      this.currentStatus = licenceDetail.currentStatus;
      this.licenceId = id;
      this.licenceUserId = userId;
      this.userSettingsModal = true;
      this.clientNotes = licenceDetail.clientNotes;
      this.invoiced = licenceDetail.invoiced;
    },
    getCountry() {
      this.$router.push('/admin/rollOut');
    },
    async updateStoreStatus() {
      try {
        await API.put(`Accounts/${this.licenceUserId}/Licence/${this.licenceId}`, {
          currentStatus: this.currentStatus,
          clientNotes: this.clientNotes,
        });
        this.getHistory(this.selectedCountry);
        this.userSettingsModal = false;
      } catch (error) {
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error while update',
        });
      }
    },
    async statusUpdate(licenceUserId, licenseId, currentStatus) {
      try {
        await API.put(`Accounts/${licenceUserId}/Licence/${licenseId}`, {
          invoiced: currentStatus,
        });
      } catch (error) {
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Unable to update status',
        });
      }
    },
    async showLicenseDetail(licenseId) {
      let licenseDetail = _.groupBy(this.history, 'id')
      licenseDetail = licenseDetail[licenseId][0]
      this.PeopleCounterPerspective = licenseDetail.maxPeoplecounter2
      this.PeopleCounterOverHead = licenseDetail.maxPeoplecounter4
      this.peopleCounterNew = licenseDetail.maxApp3
      this.heatMap = licenseDetail.maxHeatmap
      this.queueManager = licenseDetail.maxQueuemanager
      this.falseDirection = licenseDetail.falseDirection
      this.productKey = licenseDetail.productKey
      this.licenseKey = licenseDetail.licenceKey
      this.licenseDetailModal = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #d6700a;
}

input:focus + .slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}
.switch input {
  display:none;
}
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.page-item.active .page-link {
  z-index: 1;
    color: #fff;
    background-color: #6610f2 !important;
    border-color: #6610f2 !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
.Userlink {
  color: #df8031 !important;
  text-decoration: none !important;
  cursor: pointer;
}
.clearBtn {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/licenseDetail.vue